const defineToken$t = presetTokens => {
  return {
    defaultPadding: '8px 12px 8px 16px',
    withDescriptionPadding: '12px 12px 12px 16px',
    withDescriptionIconSize: 14,
    colorInfoBg: presetTokens.$alert_color_info_bg,
    colorInfo: presetTokens.$alert_info_icon_color,
    fontSizeLG: 14
  };
};

/**
 * 首字母转大写
 * @param str 字符串
 * @returns
 */
const upperFirst = str => {
  try {
    return str.replace(/^\w/, match => match.toUpperCase());
  } catch (error) {
    console.log('[upperFirst]catch:', error);
    return str;
  }
};
/**
 * fliter 未赋值的token
 * @param tokens
 * @returns
 */
const filterToken = tokens => {
  const filterTokens = {};
  for (const key of Object.keys(tokens)) {
    if (tokens[key] !== undefined) {
      filterTokens[key] = tokens[key];
    }
  }
  return filterTokens;
};
const defineColorMapToken = presetTokens => {
  return {
    // 二级Token-品牌色
    colorPrimaryBg: presetTokens.$color_brand_light_bg_default,
    colorPrimaryBgHover: presetTokens.$color_brand_light_bg_hover,
    colorPrimaryBorder: presetTokens.$color_brand_border_default,
    colorPrimaryBorderHover: presetTokens.$color_brand_border_hover,
    colorPrimaryHover: presetTokens.$color_brand_bg_hover,
    colorPrimary: presetTokens.$color_brand_bg_default,
    colorPrimaryActive: presetTokens.$color_brand_bg_active,
    colorPrimaryTextHover: presetTokens.$color_brand_text_hover,
    colorPrimaryText: presetTokens.$color_brand_text_defalut,
    colorPrimaryTextActive: presetTokens.$color_brand_text_active,
    colorPrimaryBgDisabled: presetTokens.$color_brand_text_disabled,
    // 二级Token-成功色
    colorSuccessBg: presetTokens.$color_success_light_bg_default,
    colorSuccessBgHover: presetTokens.$color_success_light_bg_hover,
    colorSuccessBorder: presetTokens.$color_success_border_default,
    colorSuccessBorderHover: presetTokens.$color_success_border_hover,
    colorSuccessHover: presetTokens.$color_success_bg_hover,
    colorSuccess: presetTokens.$color_success_bg_default,
    colorSuccessActive: presetTokens.$color_success_bg_active,
    colorSuccessTextHover: presetTokens.$color_success_text_hover,
    colorSuccessText: presetTokens.$color_success_text_defalut,
    colorSuccessTextActive: presetTokens.$color_success_text_active,
    // 二级Token-警戒色-warigin
    colorWarningBg: presetTokens.$color_warning_light_bg_default,
    colorWarningBgHover: presetTokens.$color_warning_light_bg_hover,
    colorWarningBorder: presetTokens.$color_warning_border_default,
    colorWarningBorderHover: presetTokens.$color_warning_border_hover,
    colorWarningHover: presetTokens.$color_warning_bg_hover,
    colorWarning: presetTokens.$color_warning_bg_default,
    colorWarningActive: presetTokens.$color_warning_bg_active,
    colorWarningTextHover: presetTokens.$color_warning_text_hover,
    colorWarningText: presetTokens.$color_warning_text_defalut,
    colorWarningTextActive: presetTokens.$color_warning_text_active,
    // 二级Token-警戒色-error
    colorErrorBg: presetTokens.$color_error_light_bg_default,
    colorErrorBgHover: presetTokens.$color_error_light_bg_hover,
    colorErrorBorder: presetTokens.$color_error_border_default,
    colorErrorBorderHover: presetTokens.$color_error_border_hover,
    colorErrorHover: presetTokens.$color_error_bg_hover,
    colorError: presetTokens.$color_error_bg_default,
    colorErrorActive: presetTokens.$color_error_bg_default,
    colorErrorTextHover: presetTokens.$color_error_text_hover,
    colorErrorText: presetTokens.$color_error_text_defalut,
    colorErrorTextActive: presetTokens.$color_error_text_active,
    // 超链接色
    colorLink: presetTokens.$color_brand_bg_default,
    // 二级Token-信息色
    colorInfoBg: presetTokens.$color_info_light_bg_default,
    colorInfoBgHover: presetTokens.$color_info_light_bg_hover,
    colorInfoBorder: presetTokens.$color_info_border_default,
    colorInfoBorderHover: presetTokens.$color_info_border_hover,
    colorInfoHover: presetTokens.$color_info_bg_hover,
    colorInfo: presetTokens.$color_info_bg_default,
    colorInfoActive: presetTokens.$color_info_bg_active,
    colorInfoTextHover: presetTokens.$color_info_text_hover,
    colorInfoText: presetTokens.$color_info_text_default,
    colorInfoTextActive: presetTokens.$color_info_text_active,
    // 二级Token-中性色-文本
    colorText: presetTokens.$color_neutral_primary_text,
    colorTextSecondary: presetTokens.$color_neutral_secondary_text,
    colorTextTertiary: presetTokens.$color_neutral_tertiary_text,
    colorTextQuaternary: presetTokens.$color_neutral_quaternary_text,
    // 二级Token-中性色-边框
    colorBorder: presetTokens.$color_neutral_primary_border,
    colorBorderSecondary: presetTokens.$color_neutral_secondary_border,
    // 二级Token-中性色-填充色
    colorFill: presetTokens.$color_neutral_primary_fill,
    colorFillSecondary: presetTokens.$color_neutral_secondary_fill,
    colorFillTertiary: presetTokens.$color_neutral_tertiary_fill,
    colorFillQuaternary: presetTokens.$color_neutral_quaternary_fill,
    // 二级Token-中性色-背景色
    colorBgContainer: presetTokens.$color_neutral_bg_container,
    colorBgElevated: presetTokens.$color_neutral_bg_elevated,
    colorBgLayout: presetTokens.$color_neutral_bg_layout,
    colorBgSpotlight: presetTokens.$color_neutral_bg_spotlight,
    colorBgMask: presetTokens.$color_neutral_bg_mask,
    // 不随主题变化的纯白色
    colorWhite: presetTokens.$color_grey_1
  };
};
const defineSeedMapToken = presetTokens => {
  return {
    fontFamily: presetTokens.$font_family,
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    motionUnit: 0.1,
    wireframe: false
  };
};
const defineSizeMapToken = presetTokens => {
  return {
    // ----------   FontSize   ---------- //
    //正文
    fontSize: presetTokens.$font_size_2,
    // 说明标签，以下三个不存在与antd token
    fontSizeSM: presetTokens.$font_size_1,
    fontSizeLG: presetTokens.$font_size_3,
    fontSizeXL: presetTokens.$font_size_4,
    fontSizeHeading1: presetTokens.$font_size_8,
    fontSizeHeading2: presetTokens.$font_size_6,
    fontSizeHeading3: presetTokens.$font_size_5,
    fontSizeHeading4: presetTokens.$font_size_4,
    fontSizeHeading5: presetTokens.$font_size_3,
    // ----------   FontWeigh   ---------- //
    fontWeightMedium: presetTokens.$font_weight_medium,
    fontWeightRegular: presetTokens.$font_weight_regular,
    fontWeightStrong: presetTokens.$font_weight_bold,
    // ----------   lineHeight   ---------- //
    lineHeight: presetTokens.$line_height_2,
    lineHeightSM: presetTokens.$line_height_1,
    lineHeightLG: presetTokens.$line_height_3,
    lineHeightHeading1: presetTokens.$line_height_8,
    lineHeightHeading2: presetTokens.$line_height_6,
    lineHeightHeading3: presetTokens.$line_height_5,
    lineHeightHeading4: presetTokens.$line_height_4,
    lineHeightHeading5: presetTokens.$line_height_3,
    // ----------   margin   ---------- //
    marginXXS: presetTokens.$spacing_s1,
    marginXS: presetTokens.$spacing_s2,
    marginSM: presetTokens.$spacing_s3,
    margin: presetTokens.$spacing_m1,
    marginMD: presetTokens.$spacing_m2,
    marginLG: presetTokens.$spacing_m3,
    marginXL: presetTokens.$spacing_l1,
    marginXXL: presetTokens.$spacing_l2,
    // ----------   padding   ---------- //
    paddingXXS: presetTokens.$spacing_s1,
    paddingXS: presetTokens.$spacing_s2,
    paddingSM: presetTokens.$spacing_s3,
    padding: presetTokens.$spacing_m1,
    paddingMD: presetTokens.$spacing_m2,
    paddingLG: presetTokens.$spacing_m3,
    paddingXL: presetTokens.$spacing_l1,
    paddingXXL: presetTokens.$spacing_l2,
    // ----------   controlHeight   ---------- //
    controlHeight: presetTokens.$control_height,
    controlHeightSM: presetTokens.$control_height_sm,
    controlHeightLG: presetTokens.$control_height_lg
  };
};
const defineStyleMapToken = presetTokens => {
  return {
    borderRadius: presetTokens.$radius_border_base,
    // 目前pebble基本圆角是一样的，统一使用radius_border_base，单独处理弹窗的大圆角
    borderRadiusSM: presetTokens.$radius_border_base,
    borderRadiusLG: presetTokens.$radius_border_base,
    borderRadiusXS: presetTokens.$radius_border_sm,
    boxShadow: presetTokens.$shadow_3,
    boxShadowSecondary: presetTokens.$shadow_1,
    //  ----------   Line   ---------- //
    lineWidthBold: presetTokens.$line_size_border_primary,
    lineWidth: presetTokens.$line_size_border_primary,
    lineType: presetTokens.$line_style_border_solid,
    lineWithNone: presetTokens.$line_size_border_none
  };
};

/**
 * 创建符合antd global token的集合
 * @param pebbleGlobalToken pebble 规范的global token(包含global和alias类型)
 * @returns
 */
const createAntdGlobalToken = pebbleGlobalToken => {
  setGlobalToken(pebbleGlobalToken);
  const tokens = {
    ...defineColorMapToken(pebbleGlobalToken),
    ...defineSeedMapToken(pebbleGlobalToken),
    ...defineSizeMapToken(pebbleGlobalToken),
    ...defineStyleMapToken(pebbleGlobalToken)
  };
  return filterToken(tokens);
};
let pebbleGlobalToken = {};
const setGlobalToken = token => {
  pebbleGlobalToken = token;
};
const getGlobalToken = () => {
  return pebbleGlobalToken;
};
const defineToken$s = () => {
  const globalToken = getGlobalToken();
  return {
    itemColor: globalToken.$color_grey_8,
    lastItemColor: globalToken.$color_secondary_primary,
    linkColor: globalToken.$color_grey_8,
    linkHoverColor: globalToken.$color_secondary_primary,
    separatorColor: globalToken.$color_grey_5
  };
};
const defineToken$r = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    // 默认按钮的文字颜色
    colorText: presetTokens.$button_color_text,
    // 默认按钮的边框颜色
    defaultBorderColor: presetTokens.$button_color_border,
    // 默认按钮hover边框颜色
    defaultHoverBorderColor: globalToken.$color_grey_8,
    // 默认按钮激活态边框颜色
    defaultActiveBorderColor: globalToken.$color_grey_9,
    defaultActiveBg: globalToken.$color_grey_2,
    defaultHoverColor: globalToken.$color_grey_9,
    defaultActiveColor: globalToken.$color_grey_9,
    controlHeightSM: presetTokens.$button_control_height_small,
    // 禁用色
    colorTextDisabled: presetTokens.$button_color_text_disabled,
    borderColorDisabled: presetTokens.$button_color_border_disabled,
    // text类型按钮-hover和active背景颜色
    textHoverBg: presetTokens.$button_text_bg_color_hover,
    colorTextButtonActive: presetTokens.$button_text_bg_color_active,
    // 危险禁用背景
    colorErrorDisabledBg: presetTokens.$button_color_bg_error_disabled,
    // 危险禁用文字
    colorErrorDisabledText: presetTokens.$button_color_text_error_disabled,
    // 普通按钮左右padding
    paddingInline: presetTokens.$button_control_padding_md,
    // 小按钮左右padding
    paddingInlineSM: presetTokens.$button_control_padding_sm,
    // 大按钮左右padding
    paddingInlineLG: presetTokens.$button_control_padding_lg,
    // colorLinkHover: presetTokens.$button_text_bg_color_hover,
    // colorLinkActive: presetTokens.$button_text_bg_color_active,
    textTextColor: globalToken.$color_brand_text_defalut
  };
};
const defineToken$q = presetTokens => {
  return {
    paddingLG: presetTokens.$card_padding_lg
  };
};
const defineToken$p = presetTokens => {
  const pebbleGlobalToken = getGlobalToken();
  return {
    // lineWidth: presetTokens.$checkbox_line_width,
    lineWidthBold: presetTokens.$checkbox_line_width_bold,
    colorBorder: presetTokens.$checkbox_color_border,
    colorBorderHover: presetTokens.$checkbox_color_border_hover,
    borderRadiusSM: pebbleGlobalToken.$radius_border_sm,
    colorPrimary: pebbleGlobalToken.$color_secondary_primary,
    colorPrimaryHover: pebbleGlobalToken.$color_grey_8
  };
};
const defineToken$o = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    colorPrimary: globalToken.$color_secondary_primary,
    hoverBorderColor: globalToken.$color_grey_8,
    colorBorder: presetTokens.$date_picker_color_border,
    activeShadow: 'none',
    // controlOutline: presetTokens.$date_picker_control_outline,
    // colorErrorOutline: presetTokens.$date_picker_color_error_outline,
    // controlItemBgHover: presetTokens.$date_picker_control_item_bg_hover,
    borderRadiusSM: presetTokens.$date_picker_border_radius_sm,
    activeBorderColor: globalToken.$color_grey_9,
    cellWidth: presetTokens.$date_pick_time_panel_cell_width,
    cellHeight: 28,
    withoutTimeCellHeight: 28,
    cellActiveWithRangeBg: presetTokens.$date_picker_range_cell_hover_bg
  };
};
const defineToken$n = presetTokens => {
  return {
    padding: presetTokens.$drawer_padding,
    paddingLG: presetTokens.$drawer_padding_lg
  };
};
const defineToken$m = presetTokens => {
  return {
    // 默认态
    colorText: presetTokens.$input_color_text,
    colorBorder: presetTokens.$input_color_border,
    colorPlaceholder: presetTokens.$input_color_placeholder,
    // 禁用态
    colorTextDisabled: presetTokens.$input_color_text_disabled,
    colorBgContainerDisabled: presetTokens.$input_color_bg_container_disabled,
    // size small
    controlHeightSM: presetTokens.$input_control_height_sm,
    controlHeightLG: presetTokens.$input_control_height_lg,
    hoverBorderColor: presetTokens.$input_color_border_hover,
    // inputActiveBorderColor: presetTokens.$input_color_border_active,
    activeBorderColor: presetTokens.$input_color_border_active,
    activeShadow: presetTokens.$input_shadow_active,
    colorPrimaryHover: presetTokens.$input_color_border_hover,
    fontSizeIcon: 14,
    errorActiveShadow: 'none'
  };
};
const defineToken$l = presetTokens => {
  return {
    // 默认态
    colorText: presetTokens.$input_number_color_text,
    colorBorder: presetTokens.$input_number_color_border,
    addonBg: presetTokens.$input_number_addon_bg,
    // size
    controlHeightSM: presetTokens.$input_number_control_height_sm,
    // 禁用态
    colorTextDisabled: presetTokens.$input_number_color_text_disabled,
    colorBgContainerDisabled: presetTokens.$input_number_color_bg_container_disabled,
    disabledBorderColor: presetTokens.$input_number_color_border_disabled,
    handleWidth: 17,
    handleBg: presetTokens.$input_number_handler_bg_hover,
    // hover态
    handleHoverColor: presetTokens.$input_number_color_border_active,
    hoverBorderColor: presetTokens.$input_number_color_border_hover,
    activeBorderColor: presetTokens.$input_number_color_border_active,
    activeShadow: 'none',
    handleFontSize: 10
  };
};
const defineToken$k = presetTokens => {
  return {
    colorText: presetTokens.$message_color_text,
    contentBg: presetTokens.$message_color_background,
    contentPadding: presetTokens.$message_padding
  };
};
const defineToken$j = presetTokens => {
  return {
    colorTextHeading: presetTokens.$notification_color_text_heading,
    colorText: presetTokens.$notification_color_text,
    paddingContentHorizontalLG: presetTokens.$notification_padding_content_horizontal_lg,
    paddingMD: presetTokens.$notification_padding_md,
    // lineHeightLG: presetTokens.$notification_line_height_lg,
    paddingLG: presetTokens.$notification_padding_lg,
    borderRadiusLG: 16
  };
};
const defineToken$i = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    itemActiveBg: presetTokens.$pagination_color_bg_active,
    colorPrimary: globalToken.$color_secondary_primary,
    colorPrimaryHover: globalToken.$color_secondary_primary
  };
};
const defineToken$h = presetTokens => {
  return {
    popoverPadding: presetTokens.$popover_popover_padding,
    colorText: presetTokens.$popover_color_text
  };
};
const defineToken$g = presetTokens => {
  return {
    // colorInfoBorder: presetTokens.$radio_color_info_border,
    colorBorder: presetTokens.$radio_color_border,
    colorPrimary: presetTokens.$radio_color_primary,
    colorPrimaryHover: presetTokens.$radio_color_primary,
    colorPrimaryActive: presetTokens.$radio_color_primary,
    colorPrimaryBgDisabled: presetTokens.$radio_color_primary_disabled,
    controlHeightSM: 28
  };
};
const defineToken$f = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    colorBorder: presetTokens.$select_color_border,
    // ------------ select -------------- //
    colorText: presetTokens.$select_color_text,
    hoverBorderColor: presetTokens.$select_hover_border_color,
    activeBorderColor: presetTokens.$select_input_active_border_color,
    activeOutlineColor: 'transparent',
    // ------------ dropdown -------------- //
    /**
     * option背景色
     */
    selectorBg: presetTokens.$select_dropdown_option_bg_color,
    /**
     * 默认状态: color
     */
    // selectDropdownOptionColor: presetTokens.$select_dropdown_option_color,
    // 选中状态背景
    optionSelectedBg: presetTokens.$select_control_item_bg_active,
    optionHeight: 36,
    controlHeightSM: 28,
    // 禁用状态
    colorTextDisabled: presetTokens.$select_color_text_disabled,
    colorPrimary: globalToken.$color_secondary_primary,
    // ------------ multiple -------------- //
    // 多选标签背景
    multipleItemBg: globalToken.$color_grey_3,
    multipleItemColorDisabled: globalToken.$color_grey_5,
    // 默认和禁用状态共用
    colorSplit: presetTokens.$select_color_split,
    borderRadiusXS: presetTokens.$select_border_radius_xs,
    // ------------ input(single) -------------- //
    inputHoverBorderColor: presetTokens.$select_input_hover_border_color,
    inputHoverColor: presetTokens.$select_input_hover_color,
    inputActiveBorderColor: presetTokens.$select_input_active_border_color,
    inputActiveColor: presetTokens.$select_input_active_color,
    // 错误状态下的hover
    colorErrorHover: presetTokens.$select_color_error_hover
  };
};
const defineToken$e = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    // ------------ select -------------- //
    colorText: globalToken.$color_grey_9,
    colorTextDisabled: presetTokens.$tree_select_border_default_color,
    borderRadiusSM: 4,
    colorPrimary: globalToken.$color_grey_9,
    colorPrimaryHover: globalToken.$color_grey_9,
    // ✅的粗细
    lineWidthBold: 2,
    nodeSelectedBg: globalToken.$color_grey_2,
    colorBgTextHover: globalToken.$color_grey_1
  };
};
const defineToken$d = () => {
  const globalToken = getGlobalToken();
  return {
    borderRadiusSM: 4,
    colorPrimary: globalToken.$color_grey_9,
    colorPrimaryHover: globalToken.$color_grey_9,
    // ✅的粗细
    lineWidthBold: 2,
    nodeSelectedBg: globalToken.$color_grey_2
  };
};
const defineToken$c = presetTokens => {
  return {
    handleActiveColor: presetTokens.$slider_color_track,
    colorPrimaryBorderHover: presetTokens.$slider_color_track,
    trackHoverBg: presetTokens.$slider_color_track,
    trackBg: presetTokens.$slider_color_track,
    dotActiveBorderColor: presetTokens.$slider_color_track,
    dotBorderColor: presetTokens.$slider_color_track,
    handleActiveOutlineColor: 'none',
    handleColor: presetTokens.$slider_color_track,
    handleSize: 6,
    handleLineWidth: 3,
    handleSizeHover: 8,
    handleLineWidthHover: 3
  };
};
const defineToken$b = presetTokens => {
  return {
    trackMinWidth: 36
  };
};
const defineToken$a = presetTokens => {
  return {
    colorTextHeading: presetTokens.$table_color_text_heading,
    // 字段
    // tableCellColor: presetTokens.$table_cell_color,
    rowSelectedBg: presetTokens.$table_color_fill_alter,
    rowSelectedHoverBg: presetTokens.$table_color_fill_alter,
    // 操作
    tableCellActionColor: presetTokens.$table_cell_action_color,
    headerBg: presetTokens.$table_color_fill_alter,
    // 排序状态下的td 背景色
    bodySortBg: presetTokens.$table_body_sort_bg,
    // 单元格内边距 默认大
    cellPaddingInline: 24,
    cellPaddingInlineMD: 16,
    // 单元格纵向内边距 默认大
    cellPaddingBlock: 12
  };
};
const defineToken$9 = presetTokens => {
  return {
    activeColor: presetTokens.$tabs_active_color,
    activeFontWeight: presetTokens.$tabs_active_font_weight,
    defaultFontWeight: presetTokens.$tabs_default_font_weight,
    inkBarColor: presetTokens.$tabs_ink_bar_color,
    dropColor: presetTokens.$tabs_drop_color,
    // 与原逻辑保持一致，如果需要调整，需结合tabs组件check
    inkBarSize: presetTokens.$tabs_ink_bar_size,
    activeCardColor: presetTokens.$tabs_active_card_color,
    defaultColor: presetTokens.$tabs_default_color,
    disableColor: presetTokens.$tabs_disable_color,
    hoverBGColor: presetTokens.$tabs_hover_bgcolor,
    hoverCardBGColor: presetTokens.$tabs_hover_card_bgcolor,
    hoverCardBGBorderColor: presetTokens.$tabs_hover_card_bgborder_color,
    // 横向标签页标签间距
    horizontalItemGutter: 28,
    // 横向标签padding
    horizontalItemPadding: '4px 0',
    horizontalItemPaddingLG: '4px 0',
    horizontalItemPaddingSM: '2px 0',
    colorPrimaryHover: presetTokens.$tabs_active_color,
    colorPrimaryActive: presetTokens.$tabs_active_color
  };
};
const defineToken$8 = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    colorPrimary: globalToken.$color_secondary_primary,
    defaultBg: presetTokens.$tag_default_bg,
    // 新增pebble规范token 部分未使用了，暂时没删除
    tagDefaultBg: presetTokens.$tag_default_bg,
    tagDefaultBorderColor: presetTokens.$tag_default_border_color,
    tagDefaultColor: presetTokens.$tag_default_color,
    tagDefaultBorderRadius: presetTokens.$tag_default_border_radius,
    tagDisabledBg: presetTokens.$tag_disabled_bg,
    tagDisabledBorderColor: presetTokens.$tag_disabled_border_color,
    tagDisabledColor: presetTokens.$tag_disabled_color
    // size
    // tagSizeHeightSmall: presetTokens.$tag_size_height_small,
    // tagSizeHeightMedium: presetTokens.$tag_size_height_medium,
    // tagSizeHeightLarge: presetTokens.$tag_size_height_large,
    // tagSizeFontSizeSmall: presetTokens.$tag_size_font_size_small,
    // tagSizeFontSizeMedium: presetTokens.$tag_size_font_size_medium,
    // tagSizeFontSizeLarge: presetTokens.$tag_size_font_size_large,
    // tagSizeLineHeightSmall: presetTokens.$tag_size_line_height_small,
    // tagSizeLineHeightMedium: presetTokens.$tag_size_line_height_medium,
    // tagSizeLineHeightLarge: presetTokens.$tag_size_line_height_large,
  };
};
const defineToken$7 = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    padding: 24,
    paddingXL: 48,
    itemMarginInline: presetTokens.$menu_item_margin_inline,
    activeBarHeight: 2,
    darkItemSelectedColor: '#fff',
    subMenuItemBg: '#fff',
    itemActiveBg: globalToken.$color_grey_1,
    itemHoverBg: globalToken.$color_grey_1,
    itemSelectedBg: globalToken.$color_grey_1,
    itemSelectedColor: globalToken.$color_grey_9,
    iconMarginInlineEnd: 12,
    itemColor: globalToken.$color_grey_8,
    itemBorderRadius: 12
  };
};
const defineToken$6 = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    // hover
    controlItemBgHover: presetTokens.$dropdown_control_item_bg_hover,
    // selected
    controlItemBgActive: presetTokens.$dropdown_control_item_bg_hover,
    controlItemBgActiveHover: presetTokens.$dropdown_control_item_bg_hover,
    // disalbed
    colorTextDisabled: presetTokens.$dropdown_color_text_disabled,
    fontSizeIcon: 12,
    colorPrimary: globalToken.$color_secondary_primary
  };
};
const defineToken$5 = presetTokens => {
  return {};
};
const defineToken$4 = presetTokens => {
  return {
    lineWidthHeight: presetTokens.$steps_width_height,
    dotlineWidthHeight: presetTokens.$steps_dot_width_height,
    dotActivelineWidthHeight: presetTokens.$steps_dot_active_width_height,
    finishTextColor: presetTokens.$steps_finish_text_color,
    unfinishTextColor: presetTokens.$steps_unfinish_text_color,
    processCircleWidth: presetTokens.$steps_process_circle_width,
    processInsetStart: presetTokens.$steps_process_inset_start,
    iconSizeSM: 24,
    iconSize: 28
  };
};
const defineToken$3 = presetTokens => {
  return {
    // default
    colorLink: presetTokens.$typography_link_text_color_default,
    // hover
    colorLinkHover: presetTokens.$typography_link_text_color_hover,
    // selected
    colorLinkActive: presetTokens.$typography_link_text_color_active,
    // disalbed
    colorTextDisabled: presetTokens.$typography_link_text_color_disabled
  };
};
const defineToken$2 = presetTokens => {
  const globalToken = getGlobalToken();
  return {
    // selected
    optionSelectedBg: globalToken.$color_neutral_secondary_fill,
    // 复选框的圆角
    borderRadiusSM: 4,
    menuPadding: '4px 0',
    colorPrimary: globalToken.$color_grey_9,
    colorPrimaryHover: globalToken.$color_grey_9,
    // ✅的粗细
    lineWidthBold: 2,
    // padding
    paddingXXS: presetTokens.$cascader_control_item_padding
  };
};
const defineToken$1 = (presetToken = {}) => {
  return {
    dotWidth: 6,
    dotHeight: 6,
    dotActiveWidth: 12
    // dotOffset: -12
  };
};
const defineToken = () => {
  const globalToken = getGlobalToken();
  return {
    colorBorder: globalToken.$color_grey_5,
    colorPrimary: globalToken.$color_grey_9,
    colorPrimaryHover: globalToken.$color_grey_5
  };
};

/**
 * 组件常量
 */
var ComponentEnum;
(function (ComponentEnum) {
  ComponentEnum["Alert"] = "alert";
  ComponentEnum["Breadcrumb"] = "breadcrumb";
  ComponentEnum["Button"] = "button";
  ComponentEnum["Card"] = "card";
  ComponentEnum["Checkbox"] = "checkbox";
  ComponentEnum["DatePicker"] = "datePicker";
  ComponentEnum["Drawer"] = "drawer";
  ComponentEnum["Dropdown"] = "dropdown";
  ComponentEnum["InputNumber"] = "inputNumber";
  ComponentEnum["Input"] = "input";
  ComponentEnum["Menu"] = "menu";
  ComponentEnum["Message"] = "message";
  ComponentEnum["Notification"] = "notification";
  ComponentEnum["Pagination"] = "pagination";
  ComponentEnum["Popover"] = "popover";
  ComponentEnum["Radio"] = "radio";
  ComponentEnum["Select"] = "select";
  ComponentEnum["Slider"] = "slider";
  ComponentEnum["Switch"] = "switch";
  ComponentEnum["Table"] = "table";
  ComponentEnum["Tabs"] = "tabs";
  ComponentEnum["Tag"] = "tag";
  ComponentEnum["Modal"] = "modal";
  ComponentEnum["Steps"] = "steps";
  ComponentEnum["Typography"] = "typography";
  ComponentEnum["Cascader"] = "cascader";
  ComponentEnum["TreeSelect"] = "treeSelect";
  ComponentEnum["Carousel"] = "carousel";
  ComponentEnum["Upload"] = "upload";
  ComponentEnum["Tree"] = "tree";
})(ComponentEnum || (ComponentEnum = {}));
const cDefines = {
  [ComponentEnum.Alert]: defineToken$t,
  [ComponentEnum.Button]: defineToken$r,
  [ComponentEnum.Table]: defineToken$a,
  [ComponentEnum.Message]: defineToken$k,
  [ComponentEnum.Switch]: defineToken$b,
  [ComponentEnum.Tag]: defineToken$8,
  [ComponentEnum.Pagination]: defineToken$i,
  [ComponentEnum.Breadcrumb]: defineToken$s,
  [ComponentEnum.Slider]: defineToken$c,
  [ComponentEnum.Tabs]: defineToken$9,
  [ComponentEnum.Popover]: defineToken$h,
  [ComponentEnum.Radio]: defineToken$g,
  [ComponentEnum.InputNumber]: defineToken$l,
  [ComponentEnum.Card]: defineToken$q,
  [ComponentEnum.Input]: defineToken$m,
  [ComponentEnum.Select]: defineToken$f,
  [ComponentEnum.TreeSelect]: defineToken$e,
  [ComponentEnum.DatePicker]: defineToken$o,
  [ComponentEnum.Drawer]: defineToken$n,
  [ComponentEnum.Checkbox]: defineToken$p,
  [ComponentEnum.Notification]: defineToken$j,
  [ComponentEnum.Menu]: defineToken$7,
  [ComponentEnum.Dropdown]: defineToken$6,
  [ComponentEnum.Modal]: defineToken$5,
  [ComponentEnum.Steps]: defineToken$4,
  [ComponentEnum.Typography]: defineToken$3,
  [ComponentEnum.Cascader]: defineToken$2,
  [ComponentEnum.Carousel]: defineToken$1,
  [ComponentEnum.Upload]: defineToken,
  [ComponentEnum.Tree]: defineToken$d
};
/**
 * 创建符合antd的组件token
 * @param componentTokenMap
 */
const createAntdComponentToken = componentTokenMap => {
  const cTokenMap = {};
  for (const cName of Object.keys(cDefines)) {
    const componentDefine = cDefines[cName];
    if (componentDefine) {
      const cOriginTokens = componentTokenMap[cName];
      // 当未传入自定义token的时候，也运行defineToken函数，去生产默认token
      const tokens = componentDefine(cOriginTokens || {});
      cTokenMap[upperFirst(cName)] = filterToken(tokens);
    }
  }
  return cTokenMap;
};

/**
 * 创建ant主题
 */
const createTheme = tokenMap => {
  return {
    // 公共style
    token: createAntdGlobalToken(tokenMap.globalToken),
    // 组件需要覆盖的style
    components: createAntdComponentToken(tokenMap.componentToken)
  };
};

export { createTheme };
